import { columns } from "../../../mocks/communityData";

export default function Columns() {
  const cardStyle = [
    "bg-accent-50 text-accent-600",
    "bg-primary-50 text-primary-500",
    "bg-secondary-50 text-secondary-500",
    "bg-accent-50 text-accent-600",
    "bg-primary-50 text-primary-500",
    "bg-secondary-50 text-secondary-500",
    "bg-accent-50 text-accent-600",
    "bg-primary-50 text-primary-500",
  ];

  return (
    <section id="column" className="mx-auto w-full max-w-6xl scroll-mt-20 px-4 py-14 md:px-6">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-accent-600">
            <i className="ri-archive-line" /> Topics
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-900 md:text-4xl">热门栏目</h2>
          <p className="mt-2 text-foreground-600">无论你追剧、听歌、聊综艺还是谈热点，总有一款栏目戳中你。</p>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {columns.map((c, i) => (
          <a
            key={i}
            href="#news"
            className="group flex flex-col justify-between rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-accent-200 hover:bg-background-100"
          >
            <div>
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl text-2xl ${cardStyle[i % cardStyle.length]}`}>
                <i className={c.icon} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-900 group-hover:text-primary-500">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
            <span className="mt-4 inline-flex w-fit items-center gap-1 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-500 transition group-hover:bg-accent-100 group-hover:text-accent-700">
              {c.tag}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}